export default __webpack_public_path__ + "static/media/caen8.3f046c84.jpg";